import EVImageCard from '/business/shared/images/initiatives/EV-card-image.jpg';
import EVImageHeader from '/business/shared/images/initiatives/EV-header.jpg';

import HydrogenCard from '/business/shared/images/initiatives/Green-hydrogen-card-image.jpg';
import HydrogenHeader from '/business/shared/images/initiatives/Green-hydrogen-header.jpg';

import HVO100Card from '/business/shared/images/initiatives/HVO100-card-image.jpg';
import HVO100Header from '/business/shared/images/initiatives/HVO100-header.jpg';

import BioethanolCard from '/business/shared/images/initiatives/Bioethanol-card-1x.jpg';
import BioethanolHeader from '/business/shared/images/initiatives/Bioethanol-header-1x.jpg';

import BiomethaneCard from '/business/shared/images/initiatives/Biomethane-card-1x.jpg';
import BiomethaneHeader from '/business/shared/images/initiatives/Biomethane-header-1x.jpg';

import otherFuelsCard from '/business/shared/images/initiatives/Fuel-card-1x.jpg';
import otherFuelsHeader from '/business/shared/images/initiatives/Fuel-card-2x.jpg';

interface InitiativeVisuals {
  cardImage: string | null;
  headerImage: string | null;
}

export const initiativeVisuals = (
  frontendEnum: string | null | undefined,
  questionTypeKey: string | null = null,
): InitiativeVisuals => {
  if (frontendEnum?.includes('to-ev')) {
    return {
      cardImage: EVImageCard,
      headerImage: EVImageHeader,
    };
  }
  if (frontendEnum?.includes('to-greenhydrogen')) {
    return {
      cardImage: HydrogenCard,
      headerImage: HydrogenHeader,
    };
  }
  if (frontendEnum?.includes('to-hvo')) {
    return {
      cardImage: HVO100Card,
      headerImage: HVO100Header,
    };
  }
  if (frontendEnum?.includes('to-bioethanol')) {
    return {
      cardImage: BioethanolCard,
      headerImage: BioethanolHeader,
    };
  }
  if (frontendEnum?.includes('to-biomethane')) {
    return {
      cardImage: BiomethaneCard,
      headerImage: BiomethaneHeader,
    };
  }
  // fallbacks
  if (questionTypeKey === 'calculation-building-emissions-other') {
    return {
      cardImage: otherFuelsCard,
      headerImage: otherFuelsHeader,
    };
  }
  return {
    cardImage: null,
    headerImage: null,
  };
};
